import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContratoComponent } from './contrato/contrato.component';
import { InfoAcademicaComponent } from './info-academica/info-academica.component';


import { LoginComponent } from './login/login.component';
import { PagoComponent } from './pago/pago.component';
import { PasswordReminderComponent } from './password-reminder/password-reminder.component';
import { ProfileComponent } from './profile/profile.component';
import { RedsysComponent } from './redsys/redsys.component';
import { ResultkoComponent } from './resultko/resultko.component';
import { ResultokComponent } from './resultok/resultok.component';
import { VerifyAuthService } from './shared/services/guard-auth/verify-auth.service';
import { TutorComponent } from './tutor/tutor.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'profile/:id',
    canActivate: [VerifyAuthService],
    component: ProfileComponent

  },
  {
    path: 'registro',
    component : TutorComponent
  },
  {
    path: 'infoacademica',
    component : InfoAcademicaComponent
  },
  {
    path: 'contrato',
    //canActivate: [VerifyAuthService],
    component : ContratoComponent
  },
  {
    path: 'pago',
    //canActivate: [VerifyAuthService],
    component : PagoComponent
  },
  {
    path: 'pago/:idTutor',
    canActivate: [VerifyAuthService],
    component : PagoComponent
  },
  {
    path: 'redsys',
    component : RedsysComponent
  },  
  {
    path: 'password-reminder',
    component : PasswordReminderComponent
  },
  {
    path: 'resultok/:idTutor',
    canActivate: [VerifyAuthService],
    component : ResultokComponent
  },
  {
    path: 'resultko/:idTutor',
    canActivate: [VerifyAuthService],
    component : ResultkoComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
